// import zipcelx from "zipcelx";
// import {useStore} from '../store'
import { configs } from '../common/config'
// import { useGeneralStore } from '../store/generalStore'

export function count(arr){
	return arr.length
}
export function isEmpty(param){
	if (param === '' || typeof param === 'undefined' || param === 'null' || param === '[]' || param === '{}' || param === null || ((typeof param === 'object') && (Object.keys(param).length === 0))) {
		return true;
	} else {
		return false;
	}
}
// export function showLoading(){
// 	useGeneralStore().setLoading(true);
// }
// export function hideLoading(){
// 	useGeneralStore().setLoading(false);
// }
export function setLocalStorage(key, value){
	localStorage.setItem(key, JSON.stringify(value));
}
export function getLocalStorage(key){
	const storageValue = localStorage.getItem(key);
	return JSON.parse(storageValue);
}
export function removeLocalStorage(key) {
	localStorage.removeItem(key);
}
export function getSlug(str) {
	if (isEmpty(str)) return "";
	str = str.replace(/([^A-Za-z0-9])/g, "-");
	str = str.replace(/([()])/g, "-");
	str = str.replace(/(-+)/g, "-");
	str = str.toLowerCase();
	return str;
}
export function removeUnderscore(text) {
	if (isEmpty(text)) return "";
	if (text.length > 0) {
			text = text.replace(/(_+)/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	}
	return text;
}
export function getPageParams(paginition,params={}) {
	params['page'] = paginition?.page;
	params['limit'] = paginition?.limit;
	return params;
}
export function errorException(status){
	if(status == 403 || status == 404){
		window.location.href = '/admin/error?c='+status;
	}
}
export function arrayMerge(routers, addRouters) {
	if(isEmpty(addRouters)) return routers;

	if (Array.isArray(addRouters)) {
		for (let i = 0; i < addRouters.length; i++) {
			const elRoute = addRouters[i];
			routers.push(elRoute);
		}
	}else{
		routers.push(addRouters);
	}
	
	return routers;
}

export function strReplace(originalString, searchString, newString){
	if(isEmpty(searchString)) return originalString;
	
	return originalString.replace(searchString, newString);
}

export function moneyFormatter(number) {
    if (isNaN(number)) {
        return number;
    }
    if (number === null) {
        number = 0;
    }
    return parseFloat(number).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fixNumberFormat(number) {
  return parseFloat(number).toFixed(0);
}

export function formatNRIC(nric) {
	if (nric.length !== 12) {
			return nric;
	}

	const x = nric.substr(0, 6);
	const y = nric.substr(6, 2);
	const z = nric.substr(8, 4);

	return `${x}-${y}-${z}`;
}

export function formatUserName(text, count = false) {
    if (text !== null) {
        const lowerCase = text.toLowerCase();
        let capitalize = lowerCase.replace(/\b\w/g, function(match) {
            return match.toUpperCase();
        });

        if (count && capitalize.length > count) {
            capitalize = capitalize.slice(0, count) + '...';
        }

        return capitalize;
    }
    return text;
}

export function shortenText(text, count = false) {
		if(isEmpty(text)) return ''
		
    if (count && text.length > count) {
        text = text.slice(0, count) + '...';
    }
    return text;
}

export function initial(name) {
	const names = name.split(' ');
	let initials = '';
	const maxInitials = 2;
	for (let i = 0; i < names.length && i < maxInitials; i++) {
			initials += names[i].charAt(0).toUpperCase();
	}
	return initials;
}

export function checkIsArray(data) {
	return Array.isArray(data);
}

export function checkHasUnderscore(str) {
	return typeof str === 'string' && str.includes('_');
}

export function openNewTab(url) {
	const newTab = window.open(url, '_blank');
	
	// Make the newly opened tab active (if allowed by the browser)
	if (newTab) {
			newTab.focus();
	} else {
			// If the new tab couldn't be opened (e.g., due to pop-up blocker), provide a message
			console.log('New tab blocked. Please allow pop-ups for this site and try again.');
	}
}

export function aesDecrypt(text) {
	const algorithm = 'aes-256-cbc';
	const textParts = text.split(':');
	const iv = Buffer.from(textParts.shift(), 'hex');
	const encryptedText = Buffer.from(textParts.join(':'), 'hex');
	const decipher = crypto.createDecipheriv(algorithm, Buffer.from(configs.aesKey), iv);
	let decrypted = decipher.update(encryptedText);
	decrypted = Buffer.concat([decrypted, decipher.final()]);
	return decrypted.toString();
}

export function getBasketColor(color) {
	const BASKET_COLOR = {
		'Green': '#0BC196',
		'Yellow': '#F2A818',
		'Orange': '#F26B09',
		'Pink': '#F209DF',
		'Red': '#BB342C',
		'Silver': '#73839C',
	};
  
	return BASKET_COLOR[color] || null;
}

export function getStatusColor(color) {
	const STATUS_COLOR = {
		'Draft': '#73839C',
		'Reserved': '#DC9A0F',
		'Pending': '#DC9A0F',
		'Booked': '#C61818',
		'Open': '#0BC196',
		'Approved': '#0BC196',
		'Active': '#0BC196',
		'Expired': '#DC3545',
	};
  
	return STATUS_COLOR[color] || null;
}

export function getSelectOpt(arrData,keyValue = 'value',keyLabel = 'label', type = null) {
	if(isEmpty(arrData) || !Array.isArray(arrData)) return [];
	
	if(type) {
		return Array.from(arrData).map((o) => ({
			value: o[keyValue] + ', ' + o[type]['name'],
			label: o[keyLabel] + ', ' + o[type]['name']
		}))
	}

	return Array.from(arrData).map((o) => ({
		value: o[keyValue],
		label: o[keyLabel]
	}))
}	

export function getProductDetail(product) {
	switch (product.prod_type) {
		case 'property':
			return product.product_detail.prod_pm_project_name
		case 'personal_loan':
			return 'PL - RM ' + this.moneyFormatter(product.product_detail.prod_pl_loan_amount)
		case 'mortgage':
			return product.product_detail.prod_pm_project_name
		case 'refinance':
			return 'Refinance - RM ' + this.moneyFormatter(product.product_detail.prod_ref_loan_amount)
		case 'insurance':
			return product.product_detail.prod_ins_package + ' - RM ' + this.moneyFormatter(product.product_detail.prod_ins_premium_cover)
		case 'other':
			return product.product_detail.prod_oth_type
		// Handle other cases as needed
		default:
			return '-';
	}
}
export function preventNonNumericInput(event) {
	const keyCode = event.keyCode || event.which
	const keyValue = String.fromCharCode(keyCode)
	const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/
	const allowedKeys = [8, 37, 38, 39, 40, 46]
	if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
		return event.preventDefault()
	}
}

export function formatMoney(value) {
	// const k = Number(value.key)
	const k = Number(value)
	if (typeof k !== 'number') {
		return value;
	}
	const s =  new Intl.NumberFormat('en-US', {
		style: 'decimal',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format(k);

	return s
}
